export default "__VITE_ASSET__CPQNEXao__"